import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Subheader from '../../sharedComponent/Subheader';
import Accordion from 'react-bootstrap/Accordion';
import MultiRangeSlider from "multi-range-slider-react";
import FilterImg from "../../assets/images/filterIcon.svg";
import CouponBadge from "../../assets/images/redCouponBadge.svg";
import Pedigree from "../../assets/images/biry.jpg";
import heartBorder from "../../assets/images/heartBorder.svg";
import rightBin from "../../assets/images/rightCheckBin.svg";
import dustbinImg from "../../assets/images/dustbinImg.svg";
import BlueHeart from "../../assets/images/blueFilledHeart.svg";
import ic_rating_start from "../../assets/images/ic_rating_start.svg";
import Dropdown from 'react-bootstrap/Dropdown';



const PetShops = () => {

    const [minValue, setMinValue] = useState(0);
    const [maxValue, setMaxValue] = useState(45);
    const [like1, setlike1] = useState(false);
    const [like2, setlike2] = useState(false);
    const [like3, setlike3] = useState(false);
    const [like4, setlike4] = useState(false);
    const [itemAdded, setItemAdded] = useState(false);

    return (
        <>
            <div className="medicinesList" id="cx-main">
        
                {/* main Cards Content */}
                <div className="row">

                    {/* Left Menu's Accordians */}
                   
                    {/* Cards Content Section */}
                    <div className="col-md-12">
                        <div className="topFilterSection">
                            <div className="txtSec">
                                <h1 className='mainTxt'>Products <span className='mutedTxt'>(Showing 1-20 of 500 Medicines)</span> </h1>
                            </div>
                            <div className="filterImg">
                                <Dropdown>
                                    <Dropdown.Toggle id="dropdown-basic">
                                        <img src={FilterImg} alt="" />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item>
                                            <div className="insdieFLex">
                                                <label className='labelSort'>Menu</label>
                                      
                                            </div>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <Link to="#">Most Popular</Link>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <Link to="#">piza</Link>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <Link to="#">Dhal</Link>
                                        </Dropdown.Item>
                                        <Dropdown.Item>
                                            <Link to="#">Ved</Link>
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                        <div className="cardsSections">
                            <div className="row">
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 colmain4">
                                    <div className="doctors-card">
                                        <div className="img-section">
                                            <span className="heart">
                                                {like1 ? (
                                                    <img
                                                        src={BlueHeart}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                ) : (
                                                    <img
                                                        src={heartBorder}
                                                        alt=""
                                                        onClick={() => setlike1(!like1)}
                                                    />
                                                )}
                                            </span>
                                            <img src={Pedigree} alt="" className="img-dr" />
                                            {itemAdded ? (
                                                <button
                                                    className="book-btn darkColor"
                                                    id="btn-added"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={rightBin} alt="" /> Item Added
                                                </button>
                                            ) : (
                                                <button
                                                    className="book-btn"
                                                    onClick={() => setItemAdded(!itemAdded)}
                                                >
                                                    <img src={dustbinImg} alt="" /> Add to Bag
                                                </button>
                                            )}
                                            <img src={CouponBadge} className="CouponBadge" alt="" />
                                        </div>

                                        <div className="name-rating">
                                            <div className="wrapper">
                                                <div className="left">
                                                    <Link to="/">
                                                        <label htmlFor="" className="name">
                                                            Pizza
                                                        </label>
                                                    </Link>
                                                </div>
                                                <div className="right">
                                                    <span className="name">4.3</span>
                                                    <img src={ic_rating_start} alt="" />
                                                </div>
                                            </div>
                                            <span className="cr-price">₹40.00</span>
                                            <span className="price">₹50.00</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="showmoreBtnBox">
                                <Link to="Cart">
                                <button className='ShowMore'>View cart</button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PetShops;
